// Configuração da API Bearer - Com Proxy Reverso
export const API_CONFIG = {
  BASE_URL: '', // Sempre usa URLs relativas (proxy reverso)
  API_KEY: process.env.REACT_APP_BEARER_API_KEY || 'ef19cf151ee3471da7b449494b3e3cb176f0834749cc65c01d992ae97bf8',
  AUTH_LOGIN: process.env.REACT_APP_AUTH_LOGIN || 'admin',
  AUTH_PASSWORD: process.env.REACT_APP_AUTH_PASSWORD || 'password123',
  ENDPOINTS: {
    AUTH: '/api/auth',
    VEHICLES: '/api/veiculo',
    VEHICLE_BY_ID: (id) => `/api/veiculo/${id}`,
    PRODUCTS: '/api/produto',
  }
};

// Log para debug das variáveis de ambiente
console.log('🔧 API Config:', {
  BASE_URL: API_CONFIG.BASE_URL,
  API_KEY: API_CONFIG.API_KEY ? '***' + API_CONFIG.API_KEY.slice(-4) : 'não definida',
  AUTH_LOGIN: API_CONFIG.AUTH_LOGIN,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_BEARER_API_KEY: process.env.REACT_APP_BEARER_API_KEY ? '***' + process.env.REACT_APP_BEARER_API_KEY.slice(-4) : 'não definida'
});

// Headers padrão para requisições
export const getDefaultHeaders = (token = null) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${API_CONFIG.API_KEY}`,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};
